<template>
  <jump-to-nav
    class="laptop:position-sticky-top laptop:padding-y-2xl"
    title="On This Page"
  >
    <list>
      <list-item hash="#background">Background</list-item>
      <list-item hash="#license">License</list-item>
      <list-item hash="#what-the-customer-may-do">What the Customer May Do</list-item>
      <list-item hash="#what-creators-may-do">What Creators May Do</list-item>
      <list-item hash="#what-creators-may-not-do">What Creators May Not Do</list-item>
      <list-item hash="#updates">Updates</list-item>
      <list-item hash="#downloads">Downloads</list-item>
      <list-item hash="#web-store-credentials-and-keys">Web Store Credentials and Keys</list-item>
      <list-item hash="#payment">Payment</list-item>
      <list-item hash="#term">Term</list-item>
      <list-item hash="#enforcement">Enforcement</list-item>
      <list-item hash="#guarantee">Guarantee</list-item>
      <list-item hash="#disclaimer">Disclaimer</list-item>
      <list-item hash="#limited-damages">Limited Damages</list-item>
      <list-item hash="#general-contract-terms">General Contract Terms</list-item>
    </list>
  </jump-to-nav>
</template>
<script>
  import JumpToNav from 'app/components-wa/nav/JumpToNav'
  import JumpToNavList from 'app/components-wa/nav/JumpToNavList'
  import JumpToNavListItem from 'app/components-wa/nav/JumpToNavListItem'

  export default {
    name: 'InPageNav',

    components: {
      JumpToNav,
      List: JumpToNavList,
      ListItem: JumpToNavListItem
    }
  }
</script>
